import React from "react";
import LegalShell from "../components/LegalShell";

export default function Terms() {
  return (
    <LegalShell title="Terms of Service" kicker="Legal" testid="page-tos">
      <p>Welcome to <b>Giffwurldaunce</b>. By creating an account or using our app you agree to these Terms.</p>
      <h3 className="text-cream font-black text-lg mt-6">1. Eligibility</h3>
      <p>You must be at least 13 years old (16 in some regions) to use the app. If you are under 18, you must have parental consent.</p>
      <h3 className="text-cream font-black text-lg mt-6">2. Your content</h3>
      <p>You own your content. By posting, you grant Giffwurldaunce a non-exclusive, royalty-free license to display, distribute, promote, and store your content on the platform.</p>
      <h3 className="text-cream font-black text-lg mt-6">3. Prohibited behaviour</h3>
      <p>You may not post content that is illegal, abusive, sexually explicit involving minors, hateful, harassing, or that infringes intellectual property. See the Community Guidelines for the full list.</p>
      <h3 className="text-cream font-black text-lg mt-6">4. Coins, gifts & payouts</h3>
      <p>Coins are a non-refundable digital currency used within the app. Gifts you receive convert to Pearl earnings at the platform's published rate (50% by default). Creator cashouts are processed via PayPal within 5 business days of request.</p>
      <h3 className="text-cream font-black text-lg mt-6">5. Account termination</h3>
      <p>We may suspend or terminate accounts that violate these Terms or our Community Guidelines.</p>
      <h3 className="text-cream font-black text-lg mt-6">6. Disclaimers & liability</h3>
      <p>The service is provided "as is". To the maximum extent permitted by law, Giffwurldaunce disclaims all warranties and limits its liability to the amount you paid us in the prior 12 months.</p>
      <h3 className="text-cream font-black text-lg mt-6">7. Changes</h3>
      <p>We may update these Terms. Continued use after changes constitutes acceptance.</p>
      <h3 className="text-cream font-black text-lg mt-6">8. Contact</h3>
      <p>Questions? Email <b>support@giffwurldaunce.com</b>.</p>
    </LegalShell>
  );
}
